import React from 'react';
import axios from 'axios';
import _ from 'lodash';
import Alert from '../views/alert';
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import config from '../../variables/config';
import { BarLoader } from 'react-spinners';

import {
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
  injectStripe,
  Elements
} from 'react-stripe-elements';
import { StripeProvider } from 'react-stripe-elements';
import IosCloseCircleOutline from 'react-ionicons/lib/IosCloseCircleOutline'
import IosArrowRoundBack from 'react-ionicons/lib/IosArrowRoundBack'

const cvcText = 'CVC';
const payText = 'Pay';
const cityText = 'City';
const nameText = 'Name';
const countyText = "County";
const postcodeText = 'Postcode';
const addressOneText = 'Street 1';
const addressTwoText = 'Street 2';
const addNewCard = 'Use new card';
const paymentText = 'Card Payment';
const paySaveText = 'Save and Pay';
const cardNumberText = 'Card Number';
const expiryDateText = 'Expiry Date';
const savedCardsText = 'Saved Cards';

var cardNumberStyle = {
  base: {
    fontSize: '15px',
  }
}

const emptyAlert = {
  showAlert: false,
  message: '',
  type: '',
  callback: () => { }
}

class PaymentInner extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      numberEmpty: '',
      addNewCard: false,
      savedCards: [],
      address: {
        street1: '',
        street2: '',
        city: '',
        county: '',
        postcode: '',
        country: ''
      },
      cardInfo: {
        name: '',
        cardNumber: '',
        cvv: '',
        expMonth: '',
        expYear: '',
      },
      name: '',
      stripeErrors: {
        numberEmpty: true,
        cvcEmpty: true,
        expiryEmpty: true
      },
      alert: _.clone(emptyAlert),
      loading: true
    }
  }

  componentDidMount = () => {
    this.fetchCards();
  }

  fetchCards = async () => {
    try {
      if (this.props.user.customerId && this.props.user.customerId !== '') {
        const sourceObj = (await axios.post(config.serverURL + '/getCustomerSources', { customerId: this.props.user.customerId })).data;

        this.setState({
          loading: false,
          savedCards: sourceObj.sources.data
        })
      } else {
        this.setState({
          loading: false,
          savedCards: []
        })
      }
    } catch (error) {
      this.setState({ loading: false });
      console.log('payment - fetchCards:', error.message);
    }
  }

  showAlert = (message, type) => {
    var alert = {
      showAlert: true,
      message: message,
      type: type,
      callback: () => {
        this.setState({ alert: _.clone(emptyAlert) })
      }
    }
    this.setState({ alert })
  }

  createCard = async (save) => {
    try {
      const response = await this.props.stripe.createPaymentMethod('card', {
        billing_details: {
          name: this.state.name,
          address: {
            line1: this.state.address.street1,
            line2: this.state.address.street2,
            city: this.state.address.city,
            state: this.state.address.country,
            postal_code: this.state.address.postcode,
            country: 'GB'
          }
        }
      })


      this.setState({ loading: true })
      if (response.error) {
        this.showAlert(response.error.message, 'warning');
        return;
      }
      var paymentResponse;

      var params = {
        amount: this.props.amount,
        name: this.state.name,
        email: this.props.user.email,
        description: this.props.description || 'Booking charge',
        location: config.branch || '',
        paymentMethodId: response.paymentMethod.id
      }


      var hasCustomer = false;

      if (this.props.user.customerId && (this.props.user.customerId !== ''))
        hasCustomer = true;

      if (hasCustomer && !this.props.subscribe) {
        params.customerId = this.props.user.customerId;
        if (save)
          paymentResponse = await axios.post(config.serverURL + '/createCharge', params)
        else
          paymentResponse = await axios.post(config.serverURL + '/createChargeNoSave', params)
      } else if (!this.props.subscribe) {
        if (save)
          paymentResponse = await axios.post(config.serverURL + '/createCustomerAndCharge', params)
        else
          paymentResponse = await axios.post(config.serverURL + '/createAndChargeNoSave', params)

      } else {
        params.newCard = true;
        params.fee = this.props.fee;
        params.type = this.props.type;
        params.interval = this.props.interval;

        if (hasCustomer) {
          params.customerId = this.props.user.customerId;
        } else {
          params.newUser = {
            required: true,
            name: this.state.name,
            email: this.props.user.email
          }
        }
        paymentResponse = await axios.post(config.serverURL + '/subscriptionPay', params);

        if (this.props.setSubscription && paymentResponse.data.subscriptionId) {
          this.props.setSubscription(paymentResponse.data.subscriptionId)
        }
      }
      var paymentResult = await this.checkPaymentResponse(paymentResponse);
      this.setState({ loading: false })
      this.paymentResult(paymentResult, response.paymentMethod, hasCustomer ? undefined : paymentResponse.data.customerId);
    } catch (error) {
      this.setState({ loading: false })
      this.showAlert(error.message, 'error');
      console.log('payment - createCard:', error);
    }
  }

  payWith = async (method) => {
    try {
      this.setState({ loading: true });
      var params = {
        paymentMethodId: method.id,
        customerId: this.props.user.customerId,
        description: this.props.description || 'Booking charge',
        location: config.branch || ''
      }
      if (this.props.subscribe) {
        params.fee = this.props.fee;
        params.type = this.props.type;
        params.interval = this.props.interval;

        const paymentResponse = await axios.post(config.serverURL + '/subscriptionPay', params);
        var paymentResult1 = await this.checkPaymentResponse(paymentResponse);

        if (this.props.setSubscription && paymentResponse.data.subscriptionId) {
          this.props.setSubscription(paymentResponse.data.subscriptionId)
        }
        this.paymentResult(paymentResult1, method);
      } else {
        params.amount = this.props.amount
        const paymentResponse = await axios.post(config.serverURL + '/createCharge', params);
        var paymentResult2 = await this.checkPaymentResponse(paymentResponse);

        this.paymentResult(paymentResult2, method);
      }
      this.setState({ loading: false });
    } catch (error) {
      this.showAlert(error.message, 'error');

      this.setState({ loading: false });
      console.log('payment - payWith:', error.message);
    }
  }

  paymentResult = (paymentResult, paymentMethodObj, customerId) => {
    if (paymentResult.success) {
      if (customerId) {
        this.props.updateUser(this.props.user.id, { customerId: customerId });
      }

      var paymentMethod = {
        id: paymentMethodObj.id,
        last4: paymentMethodObj.card.last4,
        exp_year: paymentMethodObj.card.exp_year,
        exp_month: paymentMethodObj.card.exp_month,
        brand: this.formatBrand(paymentMethodObj.card.brand),
      }
      this.props.successCallback(paymentMethod);
      this.setState({ loading: false });
    } else {
      if (paymentResult.error.message) {
        this.showAlert(paymentResult.error.message, 'error');
      } else {
        this.showAlert(paymentResult.error, 'error');
      }
      this.setState({ loading: false });
    }
  }

  checkPaymentResponse = async (response) => {
    try {
      if (response.data.error) {
        return { error: response.data.error };
      } else if (response.data.requires_action) {
        var result;

        if (this.props.subscribe) {
          result = await this.props.stripe.handleCardPayment(response.data.payment_intent_client_secret, {})
        } else {
          result = await this.props.stripe.handleCardAction(response.data.payment_intent_client_secret)
        }

        if (result.error) {
          return { error: result.error }
        } else if (!this.props.subscribe) {
          return (await axios.post(config.serverURL + '/createCharge', {
            paymentIntentId: result.paymentIntent.id
          })).data;
        }

        return { success: 'true' };
      } else {
        return { success: 'true' };
      }
    } catch (error) {
      return { error: error.message };
    }
  }

  stripeElementChange = (name, e) => {
    this.setState({
      stripeErrors: {
        ...this.state.stripeErrors,
        [name]: (!e.empty && e.complete) ? false : true
      }
    });
  }

  toggleNewCard = () => {
    this.setState({
      addNewCard: !this.state.addNewCard
    })
  }

  addressChange = (property, e) => {
    this.setState({
      address: {
        ...this.state.address,
        [property]: e.target.value
      }
    })
  }

  formatExpiry = (month, year) => {
    var date = month < 10 ? '0' + month : month;
    return date + '/' + year.toString().substring(2, year.length);
  }

  formatBrand = (brandKey) => {
    switch (brandKey) {
      case 'visa':
        return 'Visa';
      case 'mastercard':
        return 'Mastercard';
      default:
        return 'Other';
    }
  }

  formatLast4 = (last4) => {
    return 'XXXX-XXXX-XXXX-' + last4;
  }

  checkForAlert = () => {
    if (this.state.alert.showAlert) {
      return <Alert alert={this.state.alert} />
    } else {
      return void (0)
    }
  }

  render() {
    return (
      <div className="paymentWrapper">
        {this.state.addNewCard && <IosArrowRoundBack onClick={() => this.toggleNewCard()} className="backIcon" fontSize="45px" color="#fff" />}
        <IosCloseCircleOutline onClick={() => this.props.closePayment()} className="closeIcon" fontSize="30px" color="#fff" />

        <div className="titleText paymentText">{paymentText}</div>
        <BarLoader
          size={150}
          color={'#fff'}
          sizeUnit={"px"}
          css={{ margin: 'auto', marginTop: 15, marginBottom: 15 }}
          loading={this.state.loading}
        />
        {this.state.addNewCard && !this.state.loading ?
          <div className='stripePaymentContainer'>
            <div className='stripeElementLabel'>{cardNumberText + ':'}</div>
            <div className='stripeElement'>
              <CardNumberElement
                style={cardNumberStyle}
                onChange={(e) => this.stripeElementChange('numberEmpty', e)}
              />
            </div>
            <div className='stripeElementLabel'>{cvcText + ':'}</div>
            <div className='stripeElement'>
              <CardCvcElement
                style={cardNumberStyle}
                onChange={(e) => this.stripeElementChange('cvcEmpty', e)}
              />
            </div>
            <div className='stripeElementLabel'>{expiryDateText + ':'}</div>
            <div className='stripeElement'>
              <CardExpiryElement
                style={cardNumberStyle}
                onChange={(e) => this.stripeElementChange('expiryEmpty', e)}
              />
            </div>
            <div className='stripeElementLabel'>{nameText + ':'}</div>
            <div className='stripeElement'>
              <input type="text" placeholder={nameText} onChange={(e) => this.setState({ name: e.target.value })} value={this.state.name} />
            </div>
            <div className='stripeElementLabel'>{addressOneText + ':'}</div>
            <div className='stripeElement'>
              <input type="text" placeholder={addressOneText} onChange={(e) => this.addressChange('street1', e)} value={this.state.address.street1} />
            </div>
            <div className='stripeElementLabel'>{addressTwoText + ':'}</div>
            <div className='stripeElement'>
              <input type="text" placeholder={addressTwoText} onChange={(e) => this.addressChange('street2', e)} value={this.state.address.street2} />
            </div>
            <div className='stripeElementLabel'>{cityText + ':'}</div>
            <div className='stripeElement'>
              <input type="text" placeholder={cityText} onChange={(e) => this.addressChange('city', e)} value={this.state.address.city} />
            </div>
            <div className='stripeElementLabel'>{countyText + ':'}</div>
            <div className='stripeElement'>
              <input type="text" placeholder={countyText} onChange={(e) => this.addressChange('county', e)} value={this.state.address.county} />
            </div>
            <div className='stripeElementLabel'>{postcodeText + ':'}</div>
            <div className='stripeElement'>
              <input type="text" placeholder={postcodeText} onChange={(e) => this.addressChange('postcode', e)} value={this.state.address.postcode} />
            </div>

            <div className="paymentButtons">
              <div className="buttonWrapper marginRight" onClick={() => this.createCard(true)}>{paySaveText}</div>
              <div className="buttonWrapper" onClick={() => this.createCard(false)}>{payText}</div>
            </div>
          </div>
          :
          <div>
            {this.state.savedCards.length > 0 && !this.state.loading && <div className='stripeElementLabel'>{savedCardsText}</div>}
            {this.state.savedCards.length > 0 && !this.state.loading &&
              <div className="cardsWrapper">
                {this.state.savedCards.map((cardObj, index) => {
                  return (
                    <div className="cardRow" key={index}>
                      <div>{this.formatBrand(cardObj.card.brand)}</div>
                      <div>{this.formatLast4(cardObj.card.last4)}</div>
                      <div>{this.formatExpiry(cardObj.card.exp_month, cardObj.card.exp_year)}</div>
                      <div className="paySavedCard" onClick={() => this.payWith(cardObj)}>{payText}</div>
                    </div>
                  )
                })}
              </div>
            }
            {!this.state.loading && <div className="addNewCard" onClick={() => this.toggleNewCard()}>{addNewCard}</div>}
            <div style={{ height: 40 }}></div>
          </div>}
        {this.checkForAlert()}
      </div>
    )
  }
}
// //source = {id: '', card: { last4: '', exp_month: '', exp_year: '', brand: ''}}

const InjectedInnerPayment = injectStripe(PaymentInner)

class Payment extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      stripe: null
    };
  }
  // pk_test_L9WxcVS0CK31hatpQmooD4Jn009xWfd5OD
  // pk_live_ZzrhNvS9RvSXxmAl4VbBsMvJ00wZHv0z8C
  componentDidMount() {
    this.setState({
      stripe: window.Stripe('pk_live_ZzrhNvS9RvSXxmAl4VbBsMvJ00wZHv0z8C')
    });
  }

  render() {
    return (
      <StripeProvider stripe={this.state.stripe}>
        <div className="paymentWindow">
          <div className="paymentView">
            <Elements>
              <InjectedInnerPayment {...this.props} />
            </Elements>
          </div>
        </div>
      </StripeProvider>
    );
  };
}

const mapStateToProps = () => ({

})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {},
    dispatch
  )

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Payment)
